import * as React from 'react';

export interface SidePanelProps {
  /** Applies a data-hook HTML attribute to be used in the tests */
  dataHook?: string;
  buttonText?: string;
  /** Applies a CSS class to the component’s root element */
  className?: string;
  /** Defines a callback function which is called every time a close button is clicked. */
  onCloseButtonClick?: () => void;
  /** Defines a callback function which is called every time a help button is clicked */
  onHelpButtonClick?: () => void;
  /** Accepts any item as a child element. For standard panel layout pass compound elements of the panel:
   * * `<SidePanel.Header/>`
   * * `<SidePanel.Content/>`
   * * `<SidePanel.Footer/>`
   * * `<SidePanel.Divider/>`
   */
  children?: React.ReactNode;
  /** Controls the width of the panel */
  width?: string | number;
  /** Controls the height of the panel */
  height?: string | number;
  /** Controls the maximum height of the panel */
  maxHeight?: string | number;
  /** Specifies the skin of the side panel. */
  skin?: 'standard' | 'floating';
  /** Specifies if panel is draggable (works only with floating skin). */
  draggable?: boolean;
}
